export const CaseTransition = {
  TARN_ACCEPT: 'tarn_accept',
  TARN_ACCEPT_SUCCESS: 'tarn_accept_success',
  TARN_ACCEPT_FAIL: 'tarn_accept_fail',
};
